import auth from './auth'

export default {
  loginV2 (account) {
    return auth.loginV2(account).then(certificate => {
      if (certificate) {
        this._lifetime = certificate.expires_in
        this._save(certificate)
        this._didLogin = true
      }
      return certificate
    }).then(() => {
      return auth.userInfo().then(info => {
        if (info) {
          this._saveUserInfo(info)
        }
      })
    })
  },

  login (account) {
    return auth.login(account).then(certificate => {
      if (certificate) {
        this._lifetime = certificate.expires_in
        this._save(certificate)
        this._didLogin = true
      }
      return certificate
    }).then(() => {
      return auth.userInfo().then(info => {
        if (info) {
          this._saveUserInfo(info)
        }
      })
    })
  },

  _saveUserInfo (info) {
    this._userInfo = info
    window.localStorage.setItem('user_info', JSON.stringify(info))
  },

  autoLogin () {
    this._certificate = this._readCertificate()
    this._certificateTime = this._readCertificateTime()
    this._userInfo = this._readUserInfo()
    if (this._certificate && this._certificateTime && this._userInfo) {
      this._lifetime = this._certificate.expires_in
      auth.setAuthInfo(this._certificate)
      this._didLogin = true
      return Promise.resolve(this._certificate)
    }

    return Promise.resolve()
  },

  logout () {
    auth.logout()
    window.localStorage.removeItem('user_certificate')
    window.localStorage.removeItem('user_certificate_datatime')
    window.localStorage.removeItem('user_info')
    this._certificate = null
    this._userInfo = null
    this._certificateTime = null
    this._didLogin = false

    clearInterval(this._autoRenewInterval)
  },

  startRenewRegularly () {
    if (!this._lifetime) {
      throw new Error('Lifetime is null.')
    }

    var timeout = this._lifetime * 2 / 3

    clearInterval(this._autoRenewInterval)

    this._autoRenewInterval = setInterval(() => {
      var datatime = this._readCertificateTime()
      if (!datatime) {
        return
      }
      if (new Date().getTime() - datatime > timeout) {
        auth.renew().then(({ token }) => {
          if (this._didLogin) {
            var certificate = this._readCertificate()
            if (certificate) {
              certificate.token = token
              auth.setAuthInfo(certificate)
              this._save(certificate)
            }
          }
        }).catch(err => {
          var data = err.response && err.response.data
          if (data && data.status === 401) {
            alert('Token is invalid, please login again')
          } else {
            throw err
          }
        })
      } else {
        // user_certificate 已被其他app改变
        if (this._certificateTime < datatime) {
          this._certificate = this._readCertificate()
          this._userInfo = this._readUserInfo()
          this._certificateTime = datatime
          auth.setAuthInfo(this._certificate)
        }
      }
    }, this._lifetime / 6)
  },

  checkLoginStatus () {
    this._certificate = this._readCertificate()
    auth.setAuthInfo(this._certificate)
    return new Promise(resolve => {
      auth.userInfo().then(() => {
        resolve(true)
      }).catch(() => {
        resolve(false)
      })
    })
  },

  getCertificate () {
    return this._certificate
  },

  getUserInfo () {
    return this._userInfo
  },

  get authHeader () {
    return auth.authHeader
  },

  _readUserInfo () {
    var userInfo = window.localStorage.getItem('user_info')
    if (userInfo) {
      userInfo = JSON.parse(userInfo)
      return userInfo
    }
  },

  _readCertificate () {
    var certificate = window.localStorage.getItem('user_certificate')
    if (certificate) {
      certificate = JSON.parse(certificate)
      return certificate
    }
  },

  _readCertificateTime () {
    var datatime = window.localStorage.getItem('user_certificate_datatime')
    if (!datatime) {
      return
    }

    return Number(datatime)
  },

  _save (certificate) {
    this._certificate = certificate
    this._certificateTime = new Date().getTime()
    window.localStorage.setItem('user_certificate', JSON.stringify(certificate))
    window.localStorage.setItem('user_certificate_datatime', this._certificateTime.toString())
  }
}
